import { FC } from 'react';
import styled from 'styled-components';

import { ReactComponent as ExclamationMarkIcon } from 'assets/icons/exclamation-mark.svg';

import { H5, PSmall } from 'shared/components/Typography';
import { Spacer } from 'shared/components/Layout';
import { Wrapper } from 'shared/components/Wrapper';
import { maintenanceNotice } from 'shared/config/MaintenanceNotice';
import { valencia } from 'shared/config/Colors';

import { testId } from 'tests/utils';

import SVG from './SVG';

/**
 * Same visual language as FormStatusMessage with color="valencia",
 * but without its fade out animation - this note has to stay visible.
 */
export const MaintenanceNoteBox = styled.div`
  background-color: ${({ theme }) => theme.fairPink};
  border: 1px solid ${({ theme }) => theme.valencia};
  border-radius: 8px;
  padding: 13px 15px;
  width: 100%;
`;

const MaintenanceNoteTitle = styled(H5)`
  color: ${({ theme }) => theme.valencia};
  margin: 0;
`;

interface MaintenanceNoteProps {
  className?: string;
}

const MaintenanceNote: FC<MaintenanceNoteProps> = ({ className }) => {
  return (
    <MaintenanceNoteBox className={className} {...testId('maintenance-note')}>
      <Wrapper flex alignStart>
        <SVG
          icon={<ExclamationMarkIcon width={16} height={16} />}
          color={valencia}
        />

        <Spacer w="10px" />

        <Wrapper>
          <MaintenanceNoteTitle>{maintenanceNotice.title}</MaintenanceNoteTitle>

          <Spacer h="6px" />

          <PSmall>{maintenanceNotice.message}</PSmall>
        </Wrapper>
      </Wrapper>
    </MaintenanceNoteBox>
  );
};

export default MaintenanceNote;
